import { createSelector } from 'reselect';
import CoreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import { PageSizePreferenceSelector } from 'invision-core/src/components/session/session.selectors';
import { getFilterService } from 'invision-core/src/components/injectables/injector.helper';
import i18n from 'invision-core/src/components/i18n/i18n';
import { getPeriodString } from './contract.selectors.helper';
export var ContractsStoreSelector = function ContractsStoreSelector(state) {
  return state.customercare.offeringOrder.data.availableContracts;
};
var recoverableContractUISelector = function recoverableContractUISelector(state) {
  return state.customercare.recoverableUiState.contracts || {};
};
export var IsFetchingContractsSelector = createSelector([ContractsStoreSelector], function (search) {
  return search.isFetchingResults;
});
export var ContractsSearchCriteriaSelector = createSelector([PageSizePreferenceSelector, recoverableContractUISelector], function (pageSize, recoverableUi) {
  return Object.assign({}, recoverableUi.searchCriteria, {
    PageSize: pageSize
  });
});
export var ContractsSearchResultsSelector = createSelector([ContractsStoreSelector], function (store) {
  return store.data.contracts || [];
});
export var ContractsSearchResultsViewModelSelector = createSelector([ContractsSearchResultsSelector], function (contracts) {
  var $filter = getFilterService();
  if (!contracts) {
    return [];
  }
  return contracts.map(function (contract) {
    return {
      Id: contract.Id,
      Name: contract.Name,
      AvailabilityEndDate: contract.AvailabilityEndDate ? $filter('date')(contract.AvailabilityEndDate, 'shortDate') : i18n.translate(CoreLocaleKeys.NOT_APPLICABLE),
      CurrencyCode: contract.CurrencyCode,
      MinimumSpend: contract.MinimumSpendAmount ? $filter('invCurrency')(contract.MinimumSpendAmount, contract.CurrencyCode) : $filter('invCurrency')(0, contract.CurrencyCode),
      Length: getPeriodString(contract.DurationPeriodType, contract.Duration),
      GracePeriod: contract.GracePeriod ? getPeriodString(contract.GracePeriodType, contract.GracePeriod) : i18n.translate(CoreLocaleKeys.NOT_APPLICABLE),
      TermsAndConditions: contract.TermsAndConditions || ''
    };
  });
});